<style>
.c-table-header {
  border-radius: 5px;
  border: 2px solid #7f8387;
  padding: 1rem;
}
.c-table-title {
  position: absolute;
  margin-top: -27px;
  margin-left: 1rem;
  z-index: 1;
  cursor: pointer;
}
.c-table-exfilters {
  transition: all 1s;
}
.c-table-spacer {
  margin-top: .5rem;
}
.c-table-st-clear {
  cursor: pointer;
}
.c-table-progress-overlay {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  margin-left: -1rem;
  margin-right: auto;
  margin-top: 3rem;
}
.c-table-progress-overlay.active {
  display: block;
}
@media (max-width: 1024px) {
  .c-table-sm-spacer {
    margin-top: .5rem;
  }
}
.event-details-icon {
  cursor: pointer;
}
.event-details {
  display: none;
  -webkit-transition: all .4s;
  transition: all .4s;
}
.expanded-details .event-details {
  display: block;
}
</style>
<script>
import VueSlideBar from "vue-slide-bar";
import { HalfCircleSpinner } from 'epic-spinners';
import TimeAgo from "vue2-timeago";
import {mapGetters} from "vuex";
import {Game} from "@/enums";

export default {
  props: ['server_id', 'options'],
  components: {
    VueSlideBar,
    HalfCircleSpinner,
    // eslint-disable-next-line vue/no-unused-components
    TimeAgo,
    ServerLogTable: () => import('@/components/widgets/logs/ServerLogTable')
  },
  methods: {
    handleError: function(error) {
      console.log(`[ERROR] ${error}`);
      this.error = true;
    },
    gryphonChartOptions() {
      return {}
    },
    async fetchData() {
      if(this.$refs.queryLoadingIndicator) this.$refs.queryLoadingIndicator.classList.add('active');
      let url = new URL(process.env.VUE_APP_ROOT_API + `v1/server/${this.server_id}/serverLogsQuery`);
      url.searchParams.append('page', this.currentPage);
      url.searchParams.append('limit', this.perPage);
      url.searchParams.append('category', this.category);
      url.searchParams.append('tz', Intl.DateTimeFormat().resolvedOptions().timeZone);
      url.searchParams.append('sort', JSON.stringify({
        key: this.sortBy,
        dir: this.sortDesc ? -1 : 1
      }));
      url.searchParams.append('query', JSON.stringify(this.query));
      let _queryInit = (new Date).getTime();
      try {
        let response = await fetch(url, {
          method: 'GET',
          credentials: 'include'
        });
        if(response.ok) {
          let data = await response.json();
	        this.logstore = data.meta.logstore;
          this.totalItems = parseInt(data.meta.total_items, 10);
          this.items = data.entries;
        } else {
          throw new Error(`(${this.$vnode.componentOptions.tag}) Failed with API error ${response.status}=${response.statusText} (${response.url})`);
        }
      } catch (error) {
        console.log(`[ERROR] ${error}`);
        this.query.delta = 0.0;
        this.$toast.error('Failed to contact query service');
      }

      this.query.delta = (new Date).getTime() - _queryInit;
      if(this.$refs.queryLoadingIndicator) this.$refs.queryLoadingIndicator.classList.remove('active');
    },
    currentDateTime() {
      let date = new Date();
      return `${date.getFullYear()}-${(date.getMonth()+1).pad()}-${date.getDate().pad()}T${date.getHours().pad()}:${date.getMinutes().pad()}`;
    },
    async clearSearchTerm() {
      this.query.search_term = null;
      this.currentPage = 1;
      await this.adhocSearch();
    },
    async onCategoryChange() {
      this.currentPage = 1;
      await this.adhocSearch();
    },
    async adhocSearch() {
      await this.fetchData();
    },
    filtersToggle() {
      this.query.full = !this.query.full;
    },
    supportsDamageLogs() {
      let games = [Game.DAYZ];
      return games.includes(this.options.game);
    },
    supportsInteractLogs() {
      let games = [Game.DAYZ];
      return games.includes(this.options.game);
    },
  },
  computed: {
    ...mapGetters({
      getServer: 'getServer',
      getUILanguage: 'getUILanguage',
      getDTLocale: 'getDTLocale'
    }),
    positionQuery: {
      get() {
        return `${this.query.position.coordinates[0]}, ${this.query.position.coordinates[1]}`;
      },
      set(val) {
        let f = val.match('^(-?\\d+(\\.\\d+)?),\\s*(-?\\d+(\\.\\d+)?)$');
        if(f === null) return this.$refs.positionQueryInput.$el.classList.add('is-invalid');
        else this.$refs.positionQueryInput.$el.classList.remove('is-invalid');
        let x = f[1];
        let y = f[3];
        this.query.position.coordinates = [x, y];
      }
    }
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    sortBy: {
      handler: function(value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    sortDesc: {
      handler: function(value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  },
  mounted() {
    this.fetchData().catch(error => {
      console.error(error)
    })
  },
  created() {
    this.categories.push({value: 'all', text: this.$t('components.table.filters.categories.all')});
    this.categories.push({value: 'session', text: this.$t('components.table.filters.categories.session')});
    this.categories.push({value: 'chat', text: this.$t('components.table.filters.categories.chat')});
    if(this.supportsDamageLogs()) this.categories.push({value: 'damage', text: this.$t('components.table.filters.categories.damage')});
    if(this.supportsInteractLogs()) this.categories.push({value: 'interact', text: this.$t('components.table.filters.categories.interact')});
  },
  data() {
    return {
      ready: false,
      error: false,
	    logstore: 'default',
      // Table
      items: [],
      refId: 0,
      fields: [
        {
          key: 'date',
          label: this.$t('server.view.protocol.columns.date'),
          sortable: true
        },
        {
          key: 'user',
          label: this.$t('server.view.protocol.columns.user'),
          sortable: true
        },
        {
          key: 'event',
          label: this.$t('server.view.protocol.columns.action'),
          sortable: true
        },
        {
          key: 'target',
          label: this.$t('server.view.protocol.columns.target'),
          sortable: true
        },
        {
          key: 'position',
          label: this.$t('server.view.protocol.columns.position'),
          sortable: true
        },
        {
          key: 'actions',
          label: " ",
          sortable: false
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 75, 100],
      totalItems: 0,
      sortBy: "date",
      sortDesc: true,
      category: 'all',
      categories: [],

      // Query
      queryDateStart: false,
      query: {
        delta: 0.0,
        full: false,
        search_term: null,
        date: {
          start: {
            enabled: false,
            value: this.currentDateTime()
          },
          end: {
            enabled: false,
            value: this.currentDateTime()
          }
        },
        position: {
          available: true,
          enabled: false,
          coordinates: [0.0, 0.0],
          radius: 100.0
        }
      }
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
	    <template v-if="logstore === 'atlas'">
		    <div class="alert alert-info">
			    <h4 class="alert-heading">
				    Log storage
				    <span class="badge badge-primary text-black"><i class="fad fa-flask"/> Experimental</span>
			    </h4>
			    <hr/>
			    <p class="font-size-15">
				    This log bucket is currently using our new and experimental log storage backend, should you encounter issues or unexpected behavior, please report these via ticket.<br/>
			    </p>
		    </div>
	    </template>

      <div class="c-table-header">
        <div class="c-table-title" v-on:click="filtersToggle()">
          <span class="badge badge-primary">
            <h6 class="mb-0 mt-0">
              {{ $t('components.table.filters.title') }}
              <small>
                {{ $t('components.table.filters.details') }}
              </small>
            </h6>

          </span>
        </div>
        <!-- Primary search term -->
        <div class="c-table-spacer"/> <!-- Spacer -->
        <div class="row">
          <div class="col-lg-8 col-sm-12">
            <div class="mt-lg-2">
              {{$t('components.table.filters.search_term')}}
              <span class="badge badge-primary mb-1 c-table-st-clear" v-on:click="clearSearchTerm()">
                {{ $t('components.table.filters.clear') }}
              </span>
            </div>
            <b-form-input
                for="text"
                v-model="query.search_term"
                :placeholder="$t('components.table.filters.search_term')"
                v-on:keyup="$event.keyCode === 13 ? fetchData() : null"
            />
          </div>
          <div class="col-lg-4 col-sm-12">
            <!--
            "categories": {
            "all": "All",
            "chat": "Chat",
            "death": "Kills, deaths, damage",
            "interact": "Base building"
            }
            -->
            <div class="mt-lg-2">
              {{$t('components.table.filters.category')}}
            </div>
            <b-form-select class="form-control" v-model="category" :options="categories" v-on:change="onCategoryChange()"></b-form-select>
          </div>
        </div>
        <div class="c-table-exfilters" v-if="query.full">
          <!-- Date range -->
          <div class="c-table-spacer"/> <!-- Spacer -->
          <div class="row justify-content-center">
            <div class="col">
              <div class="row">
                <div class="col-lg-3 col-sm-12 text-lg-center">
                  <b-form-checkbox
                      switch
                      v-model="query.date.start.enabled"
                      class="mt-lg-2"
                  >
                    {{ $t('components.table.filters.date.start') }}
                  </b-form-checkbox>
                </div>
                <div class="col-lg col-sm-12">
                  <div class="c-table-sm-spacer"/> <!-- Spacer -->
                  <b-form-input
                      id="date-time"
                      v-model="query.date.start.value"
                      type="datetime-local"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="c-table-sm-spacer"/> <!-- Spacer -->
              <div class="row">
                <div class="col-lg-3 col-sm-12 text-lg-center">
                  <b-form-checkbox
                    switch
                    v-model="query.date.end.enabled"
                    class="mt-lg-2"
                  >
                    {{ $t('components.table.filters.date.end') }}
                  </b-form-checkbox>
                </div>
                <div class="col-lg col-sm-12">
                  <div class="c-table-sm-spacer"/> <!-- Spacer -->
                  <b-form-input
                    id="date-time"
                    v-model="query.date.end.value"
                    type="datetime-local"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Special features, GEO etc. -->
          <template v-if="query.position.available">
          <div class="c-table-spacer"/> <!-- Spacer -->
          <div class="row justify-content-center">
            <div class="col">
              <div class="row">
                <div class="col-lg-3 col-sm-12 text-lg-center">
                  <b-form-checkbox
                      switch
                      v-model="query.position.enabled"
                      class="mt-lg-2"
                  >
                    {{ $t('components.table.filters.pos.coords') }}
                  </b-form-checkbox>
                </div>
                <div class="col-lg col-sm-12">
                  <div class="c-table-sm-spacer"/> <!-- Spacer -->
                  <div class="input-group">
                    <b-form-input
                        v-model="positionQuery"
                        ref="positionQueryInput"
                    />
                    <div class="invalid-feedback">
                      <span>
                        {{ $t('components.table.filters.pos.error') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-lg-3 col-sm-12 text-lg-center">
                  <div class="mt-lg-2">
                    {{ $t('components.table.filters.pos.radius') }}
                  </div>
                </div>
                <div class="col-lg col-sm-12">
                  <div class="c-table-sm-spacer"/> <!-- Spacer -->
                  <vue-slide-bar v-model="query.position.radius" :min="0" :max="1000" class="mt-n2" />
                </div>
              </div>
            </div>
          </div>
          </template>
        </div>
        <!-- Button -->
        <div class="c-table-spacer"/> <!-- Spacer -->
        <div class="row justify-content-center">
          <div class="col-lg-4 col-sm-12">
            <button class="btn btn-primary btn-block" v-on:click="adhocSearch()">
              <i class="fad fa-search"></i>
              {{ $t('components.table.filters.search') }}
            </button>
          </div>
        </div>
        <div class="float-right" v-if="query.delta > 0">
          <small>Query duration {{ query.delta }}ms</small>
        </div>
      </div>
      <div class="mt-2">
        <div class="c-table-progress-overlay" ref="queryLoadingIndicator">
          <div  class="info-component text-center align-middle mt-auto mb-auto">
            <div class="info-component-space">
              <half-circle-spinner :animation-duration="900" :size="64" class="align-middle d-inline-block info-component-icon"/>
            </div>
          </div>
        </div>
        <!-- Table Element -->
        <ServerLogTable :items="items" :fields="fields" :current-page="currentPage" :per-page="0" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"/>
        <!-- Table Element End -->
      </div>
      <div class="d-inline-block">
        <b-select
            class="form-control float-left"
            v-model="perPage"
            size="md"
            :options="pageOptions"
            v-on:change="adhocSearch()"
        ></b-select>
      </div>
      <b-pagination class="float-right" size="md" :total-rows="totalItems" v-model="currentPage" :per-page="perPage"></b-pagination>
    </div>
  </div>
</template>
